import { connect } from 'react-redux'
import { setConditionField } from 'actions/feature/conditions'
import { getSignalTranslation } from 'selectors/feature/inputs'
import { makeConditionSelector } from 'selectors/feature/conditions'
import HysteresisEditor from './HysteresisEditor.jsx'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()

  return (state, ownProps) => {
    const { uri, rungName } = ownProps

    const { signal, inputConfig, operator, hysteresis, units } =
      conditionSelector(state, { queryUri: uri })

    const { minValue, maxValue } =
      getSignalTranslation(state, { signal, inputConfig }) || {}

    return {
      operator,
      hysteresis,
      maxValue,
      minValue,
      rungName,
      units,
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { uri } = ownProps

  return {
    onHysteresisChange: (hysteresis) => {
      dispatch(setConditionField(uri, 'hysteresis', hysteresis))
    },
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(HysteresisEditor)
